import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import UserModel from './components/UserModel';

import MainLayout from './MainLayout';

import AlertsScreen from './screens/AlertsScreen';
import HomeScreen from './screens/HomeScreen';
import CheckingOffensesScreen from './screens/CheckingOffensesScreen';
import CheckingParkingScreen from './screens/CheckingParkingScreen';
import CheckingSettingScreen from './screens/CheckingSettingScreen';
import SettingsCitiesScreen from './screens/SettingsCitiesScreen';
import SettingsParkinglocationsScreen from './screens/SettingsParkinglocationsScreen';
import SettingsParkinglocationPlacesScreen from './screens/SettingsParkinglocationPlacesScreen';
import SettingsParkinglocationGroupsScreen from './screens/SettingsParkinglocationGroupsScreen';
import SettingsPlaceRolesScreen from './screens/SettingsPlaceRolesScreen';
import TrafficSignsScreen from './screens/TrafficSignsScreen';
import TrafficSignsStatesScreen from './screens/TrafficSignsStatesScreen';
import TrafficSignsInfosScreen from './screens/TrafficSignsInfosScreen';
import TrafficSignsMessagesScreen from './screens/TrafficSignsMessagesScreen';
import TrafficSignsLogsScreen from './screens/TrafficSignsLogsScreen';
import LcSignsScreen from './screens/LcSignsScreen';
import LcSignsMessagesScreen from './screens/LcSignsMessagesScreen';
import TimeoutSignsScreen from './screens/TimeoutSignsScreen';
import RoutesScreen from './screens/RoutesScreen';
import TinyNodeSensorsScreen from './screens/TinyNodeSensorsScreen';
import TinyNodeInfrastructuresScreen from './screens/TinyNodeInfrastructuresScreen';
import TinyNodeDataScreen from './screens/TinyNodeDataScreen';
import TinyNodeMaintenanceScreen from './screens/TinyNodeMaintenanceScreen';
import TinyNodeMessagesScreen from './screens/TinyNodeMessagesScreen';
import TinyNodeParkinglocationsScreen from './screens/TinyNodeParkinglocationsScreen';
import FleximodoSensorsScreen from './screens/FleximodoSensorsScreen';
import FleximodoMessagesScreen from './screens/FleximodoMessagesScreen';
import FleximodoParkinglocationsScreen from './screens/FleximodoParkinglocationsScreen';
import UrbioticaParkinglocationsScreen from './screens/UrbioticaParkinglocationsScreen';
import UrbioticaInfrastructuresScreen from './screens/UrbioticaInfrastructuresScreen';
import UrbioticaCountersScreen from './screens/UrbioticaCountersScreen';
import UrbioticaMessagesScreen from './screens/UrbioticaMessagesScreen';
import UrbioticaTechMessagesScreen from './screens/UrbioticaTechMessagesScreen';
import UrbioticaCounterMessagesScreen from './screens/UrbioticaCounterMessagesScreen';
import IntelliportSensorsScreen from './screens/IntelliportSensorsScreen';
import IntelliportMessagesScreen from './screens/IntelliportMessagesScreen';
import IntelliportCommandsScreen from './screens/IntelliportCommandsScreen';
import ParkingConnlocationsScreen from './screens/ParkingConnlocationsScreen';
import LocationForwardlocationsScreen from './screens/LocationForwardlocationsScreen';
import CamdetectCamerasScreen from './screens/CamdetectCamerasScreen';
import CamdetectMessagesScreen from './screens/CamdetectMessagesScreen';
import CamdetectTechdatasScreen from './screens/CamdetectTechdatasScreen';
import CamdetectErrorsScreen from './screens/CamdetectErrorsScreen';
import CamdetectParkinglocationsScreen from './screens/CamdetectParkinglocationsScreen';
import SettingsServicesScreen from './screens/SettingsServicesScreen';
import SettingsUsersScreen from './screens/SettingsUsersScreen';
import SignInScreen from './screens/SignInScreen';
import NoMatchScreen from './screens/NoMatchScreen';

import { LocaleProvider } from 'antd';
import csCZ from 'antd/lib/locale-provider/cs_CZ';
import 'moment/locale/cs';

const SignedRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route {...rest} render={props => (
    UserModel.isAuthenticated()
      ? <Layout>
        <LocaleProvider locale={csCZ}>
          <Component {...props} />
        </LocaleProvider>
      </Layout>
      : <Redirect
        to={{
          pathname: "/login",
          state: { from: props.location }
        }} />
  )} />
)

ReactDOM.render(
  <Router>
    <Switch>
      <SignedRoute layout={MainLayout} path="/" component={HomeScreen} exact />
      <SignedRoute layout={MainLayout} path="/checking/parkings" component={CheckingParkingScreen} />
      <SignedRoute layout={MainLayout} path="/checking/offenses" component={CheckingOffensesScreen} />
      <SignedRoute layout={MainLayout} path="/checking/settings" component={CheckingSettingScreen} />
      <SignedRoute layout={MainLayout} path="/trafficsigns/list" component={TrafficSignsScreen} />
      <SignedRoute layout={MainLayout} path="/trafficsigns/states" component={TrafficSignsStatesScreen} />
      <SignedRoute layout={MainLayout} path="/trafficsigns/infos" component={TrafficSignsInfosScreen} />
      <SignedRoute layout={MainLayout} path="/trafficsigns/messages" component={TrafficSignsMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/trafficsigns/logs" component={TrafficSignsLogsScreen} />
      <SignedRoute layout={MainLayout} path="/lcsigns/signs" component={LcSignsScreen} />
      <SignedRoute layout={MainLayout} path="/lcsigns/messages" component={LcSignsMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/timeoutsigns/list" component={TimeoutSignsScreen} />
      <SignedRoute layout={MainLayout} path="/routes/list" component={RoutesScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/sensors" component={TinyNodeSensorsScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/infrastructures" component={TinyNodeInfrastructuresScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/data" component={TinyNodeDataScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/maintenance" component={TinyNodeMaintenanceScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/messages" component={TinyNodeMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/parkinglocations" component={TinyNodeParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/urbiotica/infrastructures" component={UrbioticaInfrastructuresScreen} />
      <SignedRoute layout={MainLayout} path="/urbiotica/counters" component={UrbioticaCountersScreen} />
      <SignedRoute layout={MainLayout} path="/urbiotica/messages" component={UrbioticaMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/urbiotica/tech-infos" component={UrbioticaTechMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/urbiotica/counter-msgs" component={UrbioticaCounterMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/urbiotica/parkinglocations" component={UrbioticaParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/fleximodo/sensors" component={FleximodoSensorsScreen} />
      <SignedRoute layout={MainLayout} path="/fleximodo/messages" component={FleximodoMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/fleximodo/parking-locations" component={FleximodoParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/intelliport/sensors" component={IntelliportSensorsScreen} />
      <SignedRoute layout={MainLayout} path="/intelliport/messages" component={IntelliportMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/intelliport/commands" component={IntelliportCommandsScreen} />
      <SignedRoute layout={MainLayout} path="/parkingconn/parking-locations" component={ParkingConnlocationsScreen} />
      <SignedRoute layout={MainLayout} path="/locationForward/parking-locations" component={LocationForwardlocationsScreen} />
      <SignedRoute layout={MainLayout} path="/camdetect/cameras" component={CamdetectCamerasScreen} />
      <SignedRoute layout={MainLayout} path="/camdetect/messages" component={CamdetectMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/camdetect/techdatas" component={CamdetectTechdatasScreen} />
      <SignedRoute layout={MainLayout} path="/camdetect/errors" component={CamdetectErrorsScreen} />
      <SignedRoute layout={MainLayout} path="/camdetect/parkinglocations" component={CamdetectParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/alerts/all" component={AlertsScreen} />
      <SignedRoute layout={MainLayout} path="/settings/cities" component={SettingsCitiesScreen} />
      <SignedRoute layout={MainLayout} path="/settings/parkinglocations" component={SettingsParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/settings/parkinglocation-places" component={SettingsParkinglocationPlacesScreen} />
      <SignedRoute layout={MainLayout} path="/settings/parkinglocation-groups" component={SettingsParkinglocationGroupsScreen} />
      <SignedRoute layout={MainLayout} path="/settings/place-roles" component={SettingsPlaceRolesScreen} />
      <SignedRoute layout={MainLayout} path="/settings/services" component={SettingsServicesScreen} />
      <SignedRoute layout={MainLayout} path="/settings/users" component={SettingsUsersScreen} />
      <Route path="/login" component={SignInScreen} />
      <Route component={NoMatchScreen} />
    </Switch>
  </Router>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js